var map = {
	"./logo-12up.embedded.svg": 530,
	"./logo-90min.embedded.svg": 531,
	"./logo-dbltap.embedded.svg": 532,
	"./logo-ei.embedded.svg": 533,
	"./logo-floor8.embedded.svg": 534,
	"./logo-ftb90.embedded.svg": 535,
	"./logo-german_site.embedded.svg": 536,
	"./logo-ht_media.embedded.svg": 537,
	"./logo-pluralist.embedded.svg": 538,
	"./logo-theduel-mobile.embedded.svg": 539,
	"./logo-theduel.embedded.svg": 540
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1303;


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/images ^\.\/logo\-.*\.embedded\.svg$
// module id = 1303
// module chunks = 33